import { render, staticRenderFns } from "./PreRegisterForm.vue?vue&type=template&id=1086b95c"
import script from "./PreRegisterForm.vue?vue&type=script&lang=js"
export * from "./PreRegisterForm.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterForm.vue?vue&type=style&index=0&id=1086b95c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports